<template>
  <div class="container">
    <div class="main-footer">
      Copyright &copy; 2023 <strong>{{ appName }}</strong
      >. All rights reserved.
      <div class="float-right d-none d-sm-inline-block">
        Developed with
        <b-icon color="red" icon="heart-fill"></b-icon>
        <a
          class="text-reset fw-bold"
          href="/#"
          target="_blank"
          title="PT. Nash Interaksi Semesta"
          >PT. Nash Interaksi Semesta</a
        >
        Powered by KJS MARI
      </div>
    </div>
    <!-- Google tag (gtag.js) -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-LEL7R2KC8S"></script>
    <script>
      window.dataLayer = window.dataLayer || []

      function gtag() {
        dataLayer.push(arguments)
      }

      gtag('js', new Date())

      gtag('config', 'G-LEL7R2KC8S')
    </script>

    <!--Start of Tawk.to Script-->
    <script type="text/javascript">
      var Tawk_API = Tawk_API || {},
        Tawk_LoadStart = new Date()
      ;(function () {
        var s1 = document.createElement('script'),
          s0 = document.getElementsByTagName('script')[0]
        s1.async = true
        s1.src = 'https://embed.tawk.to/5f30a8375c885a1b7fb7a339/1h210m8e4'
        s1.charset = 'UTF-8'
        s1.setAttribute('crossorigin', '*')
        s0.parentNode.insertBefore(s1, s0)
      })()
    </script>
    <!--End of Tawk.to Script-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    links: [{ name: 'Beranda', Link: '/#' }],
    appName: 'SiTrendi',
    tawkToSrc: process.env.tawkToSrc
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser']),
  },
}
</script>
